import * as api from '../api';

export const createEnquiry = (enquiry) => async (dispatch) => {
	try {
		api.createEnquiry(enquiry);
	} catch (error){
		console.error(error.message);
	}
}